/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useEffectOnce } from 'react-use';
import {
  PlayCircleOutline as PlayCircleOutlineIcon,
} from '@material-ui/icons';
import {
  Button, Grid, Card, CardContent, Container, Typography, TextField, Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NotificationCard from '../Layout/components/NotificationCard';
import Player from '../shared/Player';
import uiActions from '../../redux/actions/uiActions';
import userActions from '../../redux/actions/userActions';
import guideServices from '../../redux/services/guideServices';
import newsServices from '../../redux/services/newsServices';
import useTimeCounter from '../Elearning/components/content/useTimeCounter';
import VideoCard from '../Videos/components/VideoCard';

const useStyles = makeStyles(() => ({
  playerContainer: {
    justifyContent: 'center !important',
    width: '100%',
    paddingTop: '10px',
    display: 'flex',
  },
}));

const startCloseHelp = new Date('2022-12-23');
const endCloseHelp = new Date('2023-01-02');

const Contact = ({
  changePageTitle, logout, userId, groupId,
}) => {
  const classes = useStyles();
  const [videoUrl, setVideoUrl] = useState('');
  const [guides, setGuides] = useState([]);
  const [news, setNews] = useState([]);
  const [search, setSearch] = useState('');
  const today = new Date();
  const isHelpClosed = today >= startCloseHelp && today <= endCloseHelp;

  useEffectOnce(() => {
    changePageTitle('Help');
    guideServices.getGuides()
      .then((data) => {
        setGuides(data);
        console.log(data);
      });
    newsServices.getLastNewsByType(1)
      .then((data) => {
        setNews(data);
      });
  });

  // eslint-disable-next-line no-unused-vars
  const handleClick = (_url, opt) => {
    setVideoUrl(_url);
  };

  const isIdle = useTimeCounter(userId, groupId || null);

  isIdle && logout();

  return (
    <>
      <Container style={{ textAlign: 'center' }}>
        <Grid
          container
          direction="row"
          style={{ marginTop: '1em' }}
          spacing={4}
        >
          <Grid
            item
            md={12}
          >
            <Card variant="outlined">
              <CardContent style={{ textAlign: 'center' }}>
                <Button
                  color="primary"
                  variant="contained"
                  target="_blank"
                  style={{
                    paddingTop: '15px', paddingBottom: '15px', paddingRight: '40px', paddingLeft: '40px', fontWeight: 'bold',
                  }}
                  href="https://englishworld.atlassian.net/servicedesk/customer/portal/2"
                >
                  Help desk
                </Button>
                <Divider style={{ margin: '1.5em' }} />
                <Typography component="h2" variant="h5" style={{ paddingBottom: '1em' }}>
                  Before contacting the helpdesk, here are some tips:
                </Typography>
                <div style={{
                  width: '100%', backgroundColor: '#1bb1e4', borderRadius: 5, display: 'flex', justifyContent: 'flex-start', marginTop: 25, marginBottom: 25,
                }}
                >
                  <Typography component="h2" variant="h5" style={{ padding: '0.5em', color: 'white' }}>
                    Actualités
                  </Typography>
                </div>
                <Typography component="h2" style={{ color: '#FF0000' }}>
                  Mac users with versions older than 10.12.6 may encounter problems. If possibles use a different device.
                </Typography>
                <Typography component="h2">
                  You may need to change your browser or clear your cache. Heare are some useful links for the main internet browsers.
                </Typography>
                <Grid
                  container
                  direction="row"
                  spacing={4}
                  style={{
                    marginBottom: '1em', marginTop: '2em', width: '100%', justifyContent: 'space-around', marginLeft: '1%',
                  }}
                >
                  <Button
                    href="https://support.mozilla.org/fr/kb/comment-vider-le-cache-de-firefox"
                    className="btn btn-primary"
                    style={{ width: '15%' }}
                  >
                    <img style={{ maxWidth: '3em' }} src="img/firefox.png" title="Firefox" alt="firefox" />
                  </Button>
                  <Button
                    href="https://support.google.com/accounts/answer/32050?hl=fr&co=GENIE.Platform%3DDesktop"
                    className="btn btn-primary"
                    style={{ width: '15%' }}
                  >
                    <img style={{ maxWidth: '3em' }} src="img/chrome.png" title="Chrome" alt="chrome" />
                  </Button>
                  <Button
                    href="https://support.apple.com/fr-fr/HT201265"
                    className="btn btn-primary"
                    style={{ width: '15%' }}
                  >
                    <img style={{ maxWidth: '3em' }} src="img/safari.png" title="Safari" alt="safari" />
                  </Button>
                  <Button
                    href="https://support.microsoft.com/fr-fr/microsoft-edge/afficher-et-supprimer-l-historique-du-navigateur-dans-microsoft-edge-00cf7943-a9e1-975a-a33d-ac10ce454ca4"
                    className="btn btn-primary"
                    style={{ width: '15%' }}
                  >
                    <img style={{ maxWidth: '3em' }} src="img/edge.png" title="Edge" alt="edge" />
                  </Button>
                </Grid>
                <Divider style={{ margin: '1.5em' }} />
                <Typography component="h2" style={{ marginBottom: '1em' }}>
                  Check the FAQ section first to see if we already have the solution.
                </Typography>
                <div style={{ minWidth: '60%' }}>
                  <Grid container columns={1}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'flex', right: 0, justifyContent: 'center', alignItems: 'center',
                      }}
                    >
                      <TextField
                        label="Questions"
                        id="faq"
                        placeholder="Ask a question !"
                        variant="outlined"
                        onChange={(e) => { setSearch(e.target.value); }}
                        style={{
                          height: '100%', width: '50%',
                        }}
                      />
                      <Button
                        color="primary"
                        variant="contained"
                        href={`https://englishworld.atlassian.net/servicedesk/customer/portal/2?q=${search}`}
                        style={{
                          height: '100%', width: '15%', marginLeft: 20,
                        }}
                      >
                        Search
                      </Button>
                    </Grid>
                  </Grid>
                </div>
                <Divider style={{ margin: '1.5em' }} />
                <Typography component="h2">
                  Before you start take a look at these short video guides.
                </Typography>
                {
                  videoUrl
                    ? (
                      <div className={classes.playerContainer}>
                        <Player url={videoUrl} />
                      </div>
                    )
                    : null
                }
                <Grid
                  container
                  direction="row"
                  spacing={4}
                  style={{
                    marginTop: '1em', justifyContent: 'space-around',
                  }}
                >
                  {guides.map((guide) => (
                    <VideoCard
                      key={guide._id}
                      pdf={false}
                      tags={[]}
                      title={guide.name}
                      setUrl={handleClick}
                      filename={guide.filename}
                      thumbnail={guide.thumbnail}
                      icon={<PlayCircleOutlineIcon color="secondary" />}
                      type="video"
                      createdAt={guide.created_at}
                    />
                  ))}
                </Grid>
                <div style={{
                  width: '100%', backgroundColor: '#1bb1e4', borderRadius: 5, display: 'flex', justifyContent: 'flex-start', marginTop: 25, marginBottom: 25,
                }}
                >
                  <Typography component="h2" variant="h5" style={{ padding: '0.5em', color: 'white' }}>
                    F.A.Q
                  </Typography>
                </div>
                {
                  isHelpClosed
                    ? (
                      <Typography style={{ fontSize: 14, color: 'red', textAlign: 'center' }}>
                        Notre service d'assistance est indisponible du 23/12/2022 au 02/01/2023 inclus.
                        Nous vous invitons à consulter les vidéos tutorielles et la FAQ durant cette période.
                        Toute l'équipe Medical World vous souhaite de joyeuses fêtes de fin d'année et une bonne année 2023.
                      </Typography>
                    )
                    : (
                      <Typography component="h2" style={{ marginBottom: '1em' }}>
                        Pensez à rechercher si un problème similaire a déjà été résolu dans la F.A.Q.
                      </Typography>
                    )
                }
                <div style={{ minWidth: '60%' }}>
                  <Grid container columns={1}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'flex', right: 0, justifyContent: 'center', alignItems: 'center',
                      }}
                    >
                      <TextField
                        label="F.A.Q"
                        id="faq"
                        placeholder="Posez une question !"
                        variant="outlined"
                        disabled={isHelpClosed}
                        onChange={(e) => { setSearch(e.target.value); }}
                        style={{
                          height: '100%', width: '50%',
                        }}
                      />
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={isHelpClosed}
                        href={`https://englishworld.atlassian.net/servicedesk/customer/portal/2?q=${search}`}
                        style={{
                          height: '100%', width: '15%', marginLeft: 20,
                        }}
                      >
                        Rechercher
                      </Button>
                    </Grid>
                  </Grid>
                </div>
                <div style={{
                  width: '100%', backgroundColor: '#1bb1e4', borderRadius: 5, display: 'flex', justifyContent: 'flex-start', marginTop: 25, marginBottom: 25,
                }}
                >
                  <Typography component="h2" variant="h5" style={{ padding: '0.5em', color: 'white' }}>
                    L'assistance
                  </Typography>
                </div>
                {
                  isHelpClosed
                    ? (
                      <Typography style={{ fontSize: 14, color: 'red', textAlign: 'center' }}>
                        Notre service d'assistance est indisponible du 23/12/2022 au 02/01/2023 inclus.
                        Nous vous invitons à consulter les vidéos tutorielles et la FAQ durant cette période.
                        Toute l'équipe Medical World vous souhaite de joyeuses fêtes de fin d'année et une bonne année 2023.
                      </Typography>
                    )
                    : (
                      <Typography component="h2" style={{ width: '90%', marginLeft: '5%' }}>
                        Veuillez expliquer votre problème en détail lorsque vous envoyez un ticket. Vous pouvez également
                        inclure des captures d'écran. Cela nous aidera à répondre et à résoudre votre problème plus
                        rapidement. Vous trouverez un tutoriel dans la section ci-dessus pour vous aider à comprendre
                        comment remplir et suivre vos tickets.
                      </Typography>
                    )
                }
                <Button
                  color="primary"
                  variant="contained"
                  target="_blank"
                  disabled={isHelpClosed}
                  style={{
                    marginTop: 20, padding: '15px', paddingRight: '40px', paddingLeft: '40px', fontWeight: 'bold',
                  }}
                  href="https://englishworld.atlassian.net/servicedesk/customer/portal/2"
                >
                  Accéder à l&apos;assistance
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

Contact.propTypes = {
  changePageTitle: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
};

function mapState(state) {
  const { userData } = state.user;
  const { data } = state.group;
  const { currentGroup } = state.ui;
  const userId = userData._id;
  return {
    userId, groupId: data[currentGroup]._id,
  };
}

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
  logout: userActions.logout,
};

export default connect(mapState, actionCreators)(Contact);
